import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { HiOutlineDocumentText, HiOutlineTrash, HiPlus ,HiX} from "react-icons/hi"; // Import icons
import axios from "../../utils/axios";
import Select from "react-select";
import Topbar from "../../components/Topbar";
import Sidebar from "../../components/Sidebar";
import { getUser } from "../../utils/Common";
import { useNavigate, useParams } from "react-router-dom";
import DataTable from "react-data-table-component"; // Import the DataTable

const Rooms = ({ setIsAuthenticated }) => {
  const navigate = useNavigate();
  const [isMiniSidebar, setMiniSidebar] = useState(false);
  const { url, hotel_id } = useParams();
  const [isLoading, setLoading] = useState(false);
  const [userData, setUserData] = useState([]);
  const [propData, setPropData] = useState([]);
  const [roomList, setRoomList] = useState([]); // Store room data for the table

  const [isAddModalOpen, setAddModalOpen] = useState(false);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [editingRoom, setEditingRoom] = useState(null);

  const [newRoom, setNewRoom] = useState({
    ROOM_NAME: "",
    ROOM_TYPE_ID: "",
    ROOM_DESC: "",
    ROOM_STATUS: "1",
  }); // New room form state

  const getDetailProperty = async (hotel_id) => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/detail/hotel/${hotel_id}`);
      if (response.status === 200) {
        setPropData(response.data);
      } else {
        throw new Error("Query / network reloading");
      }
    } catch (err) {
      console.log("error");
    } finally {
      setLoading(false);
    }
  };

  const getRoomList = async (hotel_id) => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/rooms/${hotel_id}`);
      if (response.status === 200) {
       
        setRoomList(response.data); // Save room data for the table
      } else {
        throw new Error("Failed to fetch room data");
      }
    } catch (err) {
      console.log("error");
    } finally {
      setLoading(false);
    }
  };

  const handleAddRoom = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        UID: userData.id,
        HOTEL_ID: hotel_id, // Map hotel ID from URL params
        ROOM_NAME: newRoom.ROOM_NAME,
        ROOM_TYPE_ID: newRoom.ROOM_TYPE_ID,
        ROOM_DESC: newRoom.ROOM_DESC,
        ROOM_STATUS: newRoom.ROOM_STATUS,
      };
      const response = await axios.post(`/api/insert/room`, payload);
     
      if (response.status === 201) {
        toast.success("Room added successfully!");
        getRoomList(hotel_id); // Add new room to table
        setAddModalOpen(false); // Close modal
      }
    } catch (error) {
      console.error("Error adding room:", error);
      alert("Failed to add room.");
    }
  };

  const handleEditRoom = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        UID: userData.id,
        ID_ROOM: editingRoom.ID_ROOM,
        ROOM_NAME: editingRoom.ROOM_NAME,
        ROOM_TYPE_ID: editingRoom.ROOM_TYPE_ID,
        ROOM_DESC: editingRoom.ROOM_DESC,
        ROOM_STATUS: editingRoom.ROOM_STATUS,
      };
      const response = await axios.post(`/api/update/room`, payload);
      if (response.status === 200) {
        toast.success(response.data.message);
        getRoomList(hotel_id);
        setEditModalOpen(false);
      }
    } catch (err) {
      console.error("Error updating room:", err);
      toast.error("Failed to add room."); 
    }
  };

  const handleDeleteRoom = async (roomId) => {
    if (window.confirm("Are you sure you want to delete this room?")) {
      try {
        const response = await axios.post(`/api/delete/room`, { ID_ROOM: roomId });
        if (response.status === 200) {
          toast.success(response.data.message);
          getRoomList(hotel_id)
        }
      } catch (error) {
        console.error("Error deleting room:", error);
        toast.error(error);
      }
    }
  };

  // Define the table columns
  const columns = [
    {
      name: "Room",
      selector: (row) => row.ROOM_NAME,
      sortable: true,
      wrap: true, // Wrap long text
    },
    {
      name: "Room Type ID",
      selector: (row) => row.ROOM_TYPE_ID,
      sortable: true,
      wrap: true, // Wrap long text
    },
    {
      name: "Description",
      selector: (row) => row.ROOM_DESC,
      sortable: true,
      wrap: true, // Wrap long text
    },
    {
      name: "Status Room",
      selector: (row) => (row.ROOM_STATUS === 1 ? "Active" : "Inactive"), // Conditional rendering
      sortable: true,
      wrap: true, // Wrap long text
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="flex items-center space-x-4">
          {/* View Details Icon */}
          <button
            className="text-blue-500 hover:text-blue-700"
            onClick={() => {
                setEditingRoom(row);
                setEditModalOpen(true);
              }}
            title="View Details"
          >
            <HiOutlineDocumentText size={20} />
          </button>
          {/* Delete Icon */}
          <button
            className="text-red-500 hover:text-red-700"
            onClick={() => handleDeleteRoom(row.ID_ROOM)}
            title="Delete Room"
          >
            <HiOutlineTrash size={20} />
          </button>
        </div>
      ),
    },
  ];

  // Custom styles for the table
  const customStyles = {
    table: {
      style: {
        border: "1px solid #ddd", // Add border around the table
      },
    },
    rows: {
      style: {
        borderBottom: "1px solid #ddd", // Add border between rows
        padding: "12px",
      },
    },
    headCells: {
      style: {
        backgroundColor: "#f4f4f4", // Light gray background for headers
        fontWeight: "bold",
        borderBottom: "1px solid #ddd",
      },
    },
    cells: {
      style: {
        wordWrap: "break-word", // Break text into the next line
        whiteSpace: "normal", // Ensure wrapping
      },
    },
    pagination: {
      style: {
        borderTop: "1px solid #ddd", // Add border on top of pagination
        paddingTop: "10px",
      },
    },
  };

  useEffect(() => {
    var userHID = localStorage.getItem("hid");
    const userSession = getUser(); // Call getUser to fetch user data from localStorage
    if (userSession) {
      setUserData(userSession); // Store user data in the state if it exists
      getDetailProperty(userHID);
      getRoomList(userHID);
    } else {
      navigate('/'); // Optionally clear the user data if not found
    }
  }, []);

  return (
    <div className="flex h-screen bg-gray-200">
      <Sidebar
        setMiniSidebar={setMiniSidebar}
        isMiniSidebar={isMiniSidebar}
        propertyID={propData.ID_HOTEL || "Loading..."}
      />

      <div className="flex-1 flex flex-col overflow-hidden">
        <Topbar 
          setMiniSidebar={setMiniSidebar} 
          isMiniSidebar={isMiniSidebar} 
        />

        <main className="flex-1 p-5 overflow-y-auto bg-gray-100">
          <div className="mb-4 text-sm text-[#101827]">
            <span>Room List</span> &gt; <span>{propData.NAME_HOTEL}</span>
          </div>

          <section className="bg-white rounded shadow-md py-4 px-6 text-[#101827] mb-6">
            <DataTable
              columns={columns}
              data={roomList}
              pagination
              customStyles={customStyles} // Apply custom styles
              progressPending={isLoading}
              highlightOnHover
              className="mt-4"
            />
          </section>
        </main>
      </div>

      {/* Floating Button */}
      <button
        className="fixed bottom-10 right-10 bg-blue-600 text-white p-4 rounded-full shadow-lg hover:bg-blue-500 transition"
        onClick={() => setAddModalOpen(true)}
        title="Add Room"
      >
        <HiPlus size={24} />
      </button>

      {/* Modal Add New */}
      {isAddModalOpen && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50" >
          <div className="bg-white rounded-lg shadow-lg w-full max-w-lg p-6">
            
            <div className="flex justify-between items-center mb-4">
              <h4 className="text-base font-semibold">New Room {propData.NAME_HOTEL}</h4>
              <HiX 
                size={24} 
                onClick={() => setAddModalOpen(false)} 
                className="text-gray-800 hover:text-gray-700 focus:outline-none cursor-pointer"
              />
            </div>
            <form onSubmit={handleAddRoom}>
              <div className="mb-2">
                <label htmlFor="room_name" className="block text-xs font-medium mb-1">
                  Room Name
                </label>
                <input
                  type="text"
                  id="room_name"
                  value={newRoom.ROOM_NAME}
                  onChange={(e) => setNewRoom({ ...newRoom, ROOM_NAME: e.target.value })}
                  className="w-full text-xs border rounded px-3 py-2"
                  required
                />
              </div>
              <div className="mb-2">
                <label htmlFor="room_name" className="block text-xs font-medium mb-1">
                  Type ID (PMS)
                </label>
                <input
                  type="text"
                  id="room_type_id"
                  value={newRoom.ROOM_TYPE_ID}
                  onChange={(e) => setNewRoom({ ...newRoom, ROOM_TYPE_ID: e.target.value })}
                  className="w-full text-xs border rounded px-3 py-2"
                  required
                />
              </div>
              <div className="mb-2">
                <label htmlFor="room_desc" className="block text-xs font-medium mb-1">
                  Room Description
                </label>
                <textarea
                  id="room_desc"
                  value={newRoom.ROOM_DESC}
                  onChange={(e) => setNewRoom({ ...newRoom, ROOM_DESC: e.target.value })}
                  className="w-full text-xs border rounded px-3 py-2"
                  rows="3"
                  required
                ></textarea>
              </div>
              <div className="mb-2">
                <label htmlFor="status" className="block text-xs font-medium mb-1">
                    Status
                </label>
                <select
                    id="room_status"
                    value={newRoom.ROOM_STATUS}
                    onChange={(e) => setNewRoom({ ...newRoom, ROOM_STATUS: e.target.value })}
                    className="w-full border text-xs rounded px-3 py-2"
                    required
                >
                    <option value="1">Active</option>
                    <option value="2">Inactive</option>
                </select>
             </div>

              <div className="flex justify-end">
                <button
                  type="button"
                  className="bg-gray-300 text-gray-800 px-4 py-2 text-xs rounded mr-2"
                  onClick={() => setAddModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-blue-600 text-white px-4 py-2 text-xs rounded hover:bg-blue-500"
                >
                  Register Room
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Room Modal */}
      {isEditModalOpen && editingRoom && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-lg">
            <div className="flex justify-between items-center mb-4">
              <h4 className="text-base font-semibold">Edit Room </h4>
              <HiX 
                size={24} 
                onClick={() => setEditModalOpen(false)} 
                className="text-gray-800 hover:text-gray-700 focus:outline-none cursor-pointer"
              />
            </div>
            <form onSubmit={handleEditRoom}>
              <div className="mb-4">
                <label htmlFor="room_name" className="block text-xs font-medium mb-1">
                  Room Name
                </label>
                <input
                  type="text"
                  id="room_name"
                  value={editingRoom.ROOM_NAME}
                  onChange={(e) =>
                    setEditingRoom({ ...editingRoom, ROOM_NAME: e.target.value })
                  }
                  className="w-full border rounded px-3 py-2 text-xs"
                  required
                />
              </div>
              <div className="mb-4">
                <label htmlFor="room_name" className="block text-xs font-medium mb-1">
                  Room type ID
                </label>
                <input
                  type="text"
                  id="room_name"
                  value={editingRoom.ROOM_TYPE_ID}
                  onChange={(e) =>
                    setEditingRoom({ ...editingRoom, ROOM_TYPE_ID: e.target.value })
                  }
                  className="w-full border rounded px-3 py-2 text-xs"
                  required
                />
              </div>
              <div className="mb-4">
                <label htmlFor="room_desc" className="block text-xs font-medium mb-1">
                  Room Description
                </label>
                <textarea
                  id="room_desc"
                  value={editingRoom.ROOM_DESC}
                  onChange={(e) =>
                    setEditingRoom({ ...editingRoom, ROOM_DESC: e.target.value })
                  }
                  className="w-full border rounded px-3 py-2 text-xs"
                  rows="4"
                  required
                ></textarea>
              </div>
              <div className="mb-4">
                <label htmlFor="room_status" className="block text-xs font-medium mb-1">
                  Status
                </label>
                <select
                  id="room_status"
                  value={editingRoom.ROOM_STATUS}
                  onChange={(e) =>
                    setEditingRoom({ ...editingRoom, ROOM_STATUS: e.target.value })
                  }
                  className="w-full border rounded px-3 py-2 text-xs"
                  required
                >
                  <option value="1">Active</option>
                  <option value="2">Inactive</option>
                </select>
              </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={() => setEditModalOpen(false)}
                  className="bg-gray-300 px-4 py-2 rounded mr-2"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-blue-600 px-4 py-2 rounded text-white"
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      )}


    </div>
  );
};

export default Rooms;
